import { getSessionTokenFromCookie } from "@kaggle/sdk";

/** The global variable that is injected with the path to Jupyter static index html. */
const JUPYTER_PATH_VARIABLE_NAME = "KAGGLE_JUPYTER_PATH";
const JUPYTERLAB_PATH_VARIABLE_NAME = "KAGGLE_JUPYTERLAB_PATH";

const IS_LOCALHOST = window.location.hostname.match(/(localhost|127\.0\.0\.1)/);

/** Gets the base URL for the Jupyter iframe. */
const getJupyterBaseUrl = () => {
  // If its localhost, omit the host from the path (relative routing).
  if (IS_LOCALHOST) {
    return "";
  }
  return "https://kkb-production.jupyter-proxy.kaggle.net";
};

/**
 * Gets the URL path for the Jupyter iframe.
 * This is statically set via JupyterUrlHtmlWebpackPlugin.ts.
 */
const getJupyterPath = () => {
  const windowFlag = JUPYTERLAB_PATH_VARIABLE_NAME;
  const jupyterPath = (window as any)[windowFlag];
  if (!jupyterPath) {
    // tslint:disable-next-line: no-console
    console.warn(
      `window.${JUPYTER_PATH_VARIABLE_NAME} was not statically set. Assuming test context.`
    );
    return "/jupyter/path/for/tests";
  }
  return jupyterPath;
};

/** Gets the query string for the Jupyter iframe. */
const getJupyterQueryString = () => `session=${getSessionTokenFromCookie()}`;

/** Gets the full URL of the Jupyter iframe. */
export const getJupyterUrl = () =>
  `${getJupyterBaseUrl()}${getJupyterPath()}?${getJupyterQueryString()}`;
